import { render, staticRenderFns } from "./TpmAnalyticsFinancialImpact.vue?vue&type=template&id=8036ecaa"
import script from "./TpmAnalyticsFinancialImpact.vue?vue&type=script&lang=ts"
export * from "./TpmAnalyticsFinancialImpact.vue?vue&type=script&lang=ts"
import style0 from "./TpmAnalyticsFinancialImpact.vue?vue&type=style&index=0&id=8036ecaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports